import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import user from './ducks/user';
import ui from './ducks/ui';
import registration from './ducks/registration';
import settings from './ducks/settings';
import registrations from './ducks/registrations';
import tips from './ducks/tips';
import projects from './ducks/projects';
import sales from './ducks/sales';
import content from './ducks/content';
import error from './ducks/error';
import notification from './ducks/notification';
import media from './ducks/media';
import data from './ducks/data';
import charts from './ducks/charts';
import reportFilter from './ducks/reportFilter';
import reportData from './ducks/reportData/';
import guestTypes from './ducks/guestTypes';
import guestRegistrations from './ducks/guestRegistrations';
import dashboard from './ducks/dashboard';
import tutorials from './ducks/tutorials';
import reasons from './ducks/reasons';
import features from './ducks/features';
import funFacts from './ducks/funFacts';
import popups from './ducks/popups';
import offline from './ducks/offline';
import subAccounts from './ducks/subAccounts';
import monthlyReportRecipients from './ducks/monthlyReportRecipients';
import monthlyReports from './ducks/monthlyReports';

const rootReducer = combineReducers({
  data,
  user,
  ui,
  registration,
  settings,
  registrations,
  reasons,
  content,
  tips,
  projects,
  sales,
  error,
  notification,
  media,
  reportFilter,
  reportData,
  routing: routerReducer,
  charts,
  guestTypes,
  guestRegistrations,
  dashboard,
  tutorials,
  features,
  funFacts,
  popups,
  offline,
  subAccounts,
  monthlyReportRecipients,
  monthlyReports
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
